module.exports = __webpack_public_path__ + "img/adilson.494cb554.jpeg";